/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { GenericBooleanRadioSection } from './GenericBooleanRadioSection';

interface SandboxSettingDefaultEnablementSectionProps {
  defaultValue: boolean | null;
  isInvalid: boolean;
  onDefaultEnablementChange: (enabledByDefault: boolean) => void;
}

export default function SandboxSettingDefaultEnablementSection({
  onDefaultEnablementChange,
  defaultValue,
  isInvalid,
}: Readonly<SandboxSettingDefaultEnablementSectionProps>) {
  const config = {
    titleKey: 'settings.sandbox_issues.default_enablement.title',
    yesLabelKey: 'on',
    noLabelKey: 'off',
    yesHelpTextKey: 'settings.sandbox_issues.default_enablement.yes.description',
    noHelpTextKey: 'settings.sandbox_issues.default_enablement.no.description',
    invalidTextKey: isInvalid ? 'settings.sandbox_issues.default_enablement.invalid' : undefined,
  };

  return (
    <GenericBooleanRadioSection
      config={config}
      onChange={onDefaultEnablementChange}
      value={defaultValue}
    />
  );
}
